var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"App"},[_c('toolbar'),_vm._v(" "),_c('main',{staticClass:"App__main"},[_c('router-view',{attrs:{"name":"calendar"}})],1)],1),_vm._v(" "),_c('section',{staticClass:"App__popups"},[_c('booking-popup')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc97b47c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 207
// module chunks = 0